import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminUserStories = lazy(() => import("@/pages/admin/AdminUserStories"));

export const Route = createFileRoute("/admin/user-stories")({
  component: AdminUserStories,
});
